export const VIEW_ALL = 'all';
export const VIEW_INBOX = 'inbox';
export const VIEW_OUTBOX = 'outbox';
